import React from "react"
import { Link } from "react-router-dom"

import "./Button.sass"

const Button = ({ to, href, children, ...rest }) => {
	return to !== undefined ? (
		<Link className="Button" to={to} {...rest}>
			{children}
		</Link>
	) : (
		<a className="Button" href={href} {...rest}>
			{children}
		</a>
	)
}

export default Button
